import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import API from '@Services/apiAxios';
import { SuccessErrorModalOpen } from '@Reducers/SuccessErrorModal';

interface DiscrepancyReportState {
  loading: boolean;
  error: string | null;
  fileUrl: string | null;
}

const initialState: DiscrepancyReportState = {
  loading: false,
  error: null,
  fileUrl: null,
};

export const fetchDiscrepancyReport = createAsyncThunk<string, string, { rejectValue: string }>(
  'purchaseInvoice/discrepancyReport',
  async (invoiceNumber, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await API.get<{ msg: string; data: string }>(
        `/invoice/purchase-invoice/discrepancy-report/${invoiceNumber}`,
      );

      return data.data;
    } catch (err) {
      const error = err as AxiosError<{ msg?: string }>;

      const errorMessage = error.response?.data?.msg || 'Something went wrong.';

      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          title: 'Oops!',
          subTitle: errorMessage,
        }),
      );

      return rejectWithValue(errorMessage);
    }
  },
);

const discrepancyReportSlice = createSlice({
  name: 'purchaseInvoiceDiscrepancyReport',
  initialState,
  reducers: {
    clearDiscrepancyReport: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDiscrepancyReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDiscrepancyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.fileUrl = action.payload;
      })
      .addCase(fetchDiscrepancyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Something went wrong';
      });
  },
});

export const { clearDiscrepancyReport } = discrepancyReportSlice.actions;
export default discrepancyReportSlice.reducer;
